// extracted by mini-css-extract-plugin
module.exports = {"admin-page":"styles_admin-page__3384W","label":"styles_label__UKsUM","textarea":"styles_textarea__1phFB"};